import React, { useEffect, useState } from 'react';
import { useComponentVisible } from '../../hooks/useComponentVisible';
import menuOptionsEditIcon from '../../assets/icons/menu-options-edit-icon.svg';
import menuOptionsDeleteIcon from '../../assets/icons/menu-options-delete-icon.svg';
import { AnimatePresence, motion } from 'framer-motion';
import './index.scss';
import { IKebabMenuProps } from '../../interfaces/kebab-menu';

export const KebabMenu = (props: IKebabMenuProps) => {
    const [isVisible, setVisibility] = useState<boolean>(false);
    const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(isVisible);
    const identifier = React.useMemo(() => { return new Date().getTime() }, []);

    const toggleVisibility = () => {
        const currentVisibility: boolean = isVisible;
        setVisibility(!currentVisibility);
        setIsComponentVisible(!currentVisibility);
    }

    const onOptionClicked = (option: 'edit' | 'delete'): void => {
        props.onOptionClicked(option, props.gameName);
        toggleVisibility();
    }

    useEffect(() => {
        if (isComponentVisible !== isVisible) {
            setVisibility(isComponentVisible);
        }
    }, [isComponentVisible]);

    return <div className='kebab-menu-container' key={`kebab-key-${identifier}`}>
        <img className='kebab-menu-options-img' src={props.optionsIcon} alt='' onClick={toggleVisibility} ref={ref} />
        <AnimatePresence key={`animated-presence-${identifier}`}>
            {isComponentVisible === true &&
                <motion.div key={`motion-div-${identifier}`}
                    className={`context-menu-container ${isVisible === true ? `shown` : `hidden`}`}
                    variants={{
                        hidden: {
                            scale: 0,
                            y: -62,
                            x: 82,
                        },
                        visible: {
                            scale: 1,
                            y: 0,
                            x: 0,
                            transition: {
                                duration: 0.5,
                                opacity: { ease: "linear" },
                                layout: { duration: 0.5 }
                            },
                        },
                    }}
                    exit="hidden"
                    initial="hidden"
                    animate="visible">
                    <div className='context-menu-item-container' onClick={() => onOptionClicked('edit')}>
                        <div className='item-image-container'>
                            <img src={menuOptionsEditIcon} alt='' />
                        </div>
                        <div className='item-text-container'>
                            <span>Edit</span>
                        </div>
                    </div>
                    {/* <div className='context-menu-item-container'>
                        <div className='item-image-container'>
                            <img src={menuOptionsScheduleIcon} alt='' />
                        </div>
                        <div className='item-text-container'>
                            <span>Schedule</span>
                        </div>
                    </div>
                    <div className='context-menu-item-container'>
                        <div className='item-image-container'>
                            <img src={menuOptionsTagIcon} alt='' />
                        </div>
                        <div className='item-text-container'>
                            <span>Tag Settings</span>
                        </div>
                    </div> */}
                    <div className='context-menu-item-container' onClick={() => onOptionClicked('delete')}>
                        <div className='item-image-container'>
                            <img src={menuOptionsDeleteIcon} alt='' />
                        </div>
                        <div className='item-text-container'>
                            <span>Delete</span>
                        </div>
                    </div>
                </motion.div>
            }
        </AnimatePresence>
    </div>
}